import styled from "@emotion/styled";
import { GuildRole } from "components/Header/WalletSection/GuildRole";
import {
  WalletAddressLabel,
  WalletContentDisplayLocations,
} from "components/Header/WalletSection/WalletAddressLabel";
import { BebopBColoredIcon } from "components/Icons";
import { ProfileIcon } from "components/general/UserIcons/ProfileIcon/ProfileIcon";
import { Link } from "react-router-dom";

interface MobileProfileBarProps {
  setIsBottomSheetOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const MobileProfileBar = ({ setIsBottomSheetOpen }: MobileProfileBarProps) => {
  return (
    <MobileProfileBarContainer>
      <UserContainer onClick={() => setIsBottomSheetOpen(true)}>
        <ProfileIcon size={32} borderRadius="8px" />
        <UserDetailsContainer>
          <WalletAddressLabel displayLocation={WalletContentDisplayLocations.NavbarV2Mobile} />
          <GuildRole displayLocation={WalletContentDisplayLocations.NavbarV2Mobile} />
        </UserDetailsContainer>
      </UserContainer>

      <Link to="/">
        <BebopLogo />
      </Link>
    </MobileProfileBarContainer>
  );
};

// Sub-components

const MobileProfileBarContainer = styled.div`
  display: flex;
  position: sticky;
  top: 0;
  justify-content: space-between;
  height: 52px;
  flex-shrink: 0;
  box-shadow: ${props => props.theme["Card Shadow"]};
  padding: 10px;
  padding-bottom: 15px;
  align-items: center;
  background-color: inherit;
  z-index: 100;
`;

export const UserContainer = styled.div`
  display: flex;
`;

const UserDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 10px;
`;

const BebopLogo = styled(BebopBColoredIcon)`
  margin-right: 6px;
`;
